var _CssBaseline;
import React from 'react';
import { node, object } from 'prop-types';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import merge from 'lodash.merge';
import { useCustomTheme } from "../../../sovos-custom-theme-context";
import SovosTheme from "../../../themes/sovos-theme";
import generateCustomTheme from "../../custom-themes/generateCustomTheme";
var MergedThemeProvider = function MergedThemeProvider(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {} : _ref$theme;
  var _useCustomTheme = useCustomTheme(),
    colorThemes = _useCustomTheme.colorThemes,
    logoAlt = _useCustomTheme.logoAlt,
    logoUrl = _useCustomTheme.logoUrl,
    selectedTheme = _useCustomTheme.selectedTheme;
  var selectedThemeIndex = colorThemes === null || colorThemes === void 0 ? void 0 : colorThemes.findIndex(function (colorTheme) {
    return colorTheme.title === selectedTheme;
  });
  var getMergedTheme = function getMergedTheme() {
    var _theme$overrides;
    return createTheme(merge({}, SovosTheme, theme,
    // selectedTheme defaults to Mosaic, so we will always generate overrides. Make sure that the logo override from the theme prop is maintained
    // unless it has been explicitly set in the context
    (selectedTheme !== null && selectedTheme !== void 0 ? selectedTheme : colorThemes) ? generateCustomTheme(colorThemes, logoAlt, logoUrl || (theme === null || theme === void 0 || (_theme$overrides = theme.overrides) === null || _theme$overrides === void 0 || (_theme$overrides = _theme$overrides.sovosNavigation) === null || _theme$overrides === void 0 ? void 0 : _theme$overrides.logoUrl), selectedThemeIndex) : null));
  };
  return /*#__PURE__*/React.createElement(StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: getMergedTheme()
  }, _CssBaseline || (_CssBaseline = /*#__PURE__*/React.createElement(CssBaseline, null)), children));
};
MergedThemeProvider.propTypes = {
  children: node.isRequired,
  theme: object
};
export default MergedThemeProvider;